import { extendTheme } from '@chakra-ui/react';
import { CardComponent } from './additions/card/card';
import { badgeStyles } from './components/badge';
import { buttonStyles } from './components/button';
import { drawerStyles } from './components/drawer';
import { headingStyles } from './components/heading';
import { inputStyles } from './components/input';
import { linkStyles } from './components/link';
import { progressStyles } from './components/progress';
import { radioStyles } from './components/radio';
import { sliderStyles } from './components/slider';
import { spinnerStyles } from './components/spinner';
import { switchStyles } from './components/switch';
import { tableStyles } from './components/table';
import { textareaStyles } from './components/textarea';
import { breakpoints } from './foundations/breakpoints';
import { globalStyles } from './styles';
import { checkboxStyles } from './components/checkbox';
import { WhiteBoxTheme } from '../v1/WhiteBox';

export default extendTheme(
  { breakpoints }, // Breakpoints
  globalStyles,
  badgeStyles, // badge styles
  buttonStyles, // button styles
  linkStyles, // link styles
  progressStyles, // progress styles
  sliderStyles, // slider styles
  inputStyles, // input styles
  textareaStyles, // textarea styles
  switchStyles, // switch styles
  spinnerStyles, // spinner styles
  CardComponent, // card component
  headingStyles, // heading styles
  drawerStyles, // drawer styles
  tableStyles, // table styles
  radioStyles, // radio styles
  checkboxStyles, // checkbox styles
  { components: { WhiteBox: WhiteBoxTheme } }
);
